<template>
  <div class="content">
    <div class="container-fluid">
       <div class="row">
        <b-modal
            id="modal-top-add"
            hide-footer
            title="Add House"
            content-class="shadow" 
          >
            <template #modal-header="{ close }">
              <h5>Add House</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <b-form
                class="text-left"
                @submit.stop.prevent="handleSubmit(submitAddForm)"
              >
                <b-row no-gutters>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="addData.buildingId"
                      @update:modelValue="
                        (newValue) => (addData.buildingId = newValue)
                      "
                        :options="buildingOptions"
                      :rules="{ required: true }"
                      id="text-building"
                      name="text-building"
                      label="Building"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-building-feedback"
                      validatorName="Building"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <VinputNumber
                      inputType="number"
                      :modelValue="addData.size"
                      @update:modelValue="updateSize"
                      :rules="{ required: true }"
                      id="text-size"
                      name="text-size"
                      label="Size"
                      class="mb-1 mr-sm-2"
                      description="text-size-feedback"
                      validatorName="Size"
                      :step=".01"
                    />
                    <div v-if="errorMessage" class="error-message">
                    {{errorMessage}}
                    </div>
                  </b-col>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <VinputNumber
                      inputType="number"
                      :modelValue="addData.floor"
                      @update:modelValue="
                        (newValue) => (addData.floor = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-floor"
                      name="text-floor"
                      label="Floor"
                      class="mb-1 mr-sm-2"
                      description="text-floor-feedback"
                      validatorName="Floor"
                      :step="1"
                    />
                  </b-col>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="addData.roomNumber"
                      @update:modelValue="
                        (newValue) => (addData.roomNumber = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-roomNumber"
                      name="text-roomNumber"
                      label="Room Number"
                      class="mb-1 mr-sm-2"
                      description="text-roomNumber-feedback"
                      validatorName="Room Number"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="addData.priceOption"
                      @update:modelValue="
                        (newValue) => (addData.priceOption = newValue)
                      "
                        :options="priceOptions"
                      :rules="{ required: true }"
                      id="text-price-options"
                      name="text-price-options"
                      label="Price Options"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-price-options-feedback"
                      validatorName="Price Options"
                    />
                  </b-col>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="addData.rentCurrencyType"
                      @update:modelValue="
                        (newValue) => (addData.rentCurrencyType = newValue)
                      "
                        :options="rentCurrencyTypeOptions"
                      :rules="{ required: true }"
                      id="text-rent-currency-options"
                      name="text-rent-currency-options"
                      label="Rent Currency"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-rent-currency-options-feedback"
                      validatorName="Rent Currency"
                    />
                  </b-col>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <VinputNumber
                      inputType="number"
                      :modelValue="addData.price"
                      @update:modelValue="addPrice"
                      :rules="{ required: true }"
                      id="text-price"
                      name="text-price"
                      label="Rent Price"
                      class="mb-1 mr-sm-2"
                      description="text-size-feedback"
                      validatorName="Rent Price"
                      :step=".01"
                    />
                  <div v-if="errorMessage1" class="error-message">
                    {{errorMessage1}}
                    </div>
                  </b-col> 
                    <b-row style="margin-left: -11px;">
                      <b-col xs="2" style="justify-content: center; align-items: center">
                        Include VAT (15%)
                      </b-col>
                      <b-col xs="2" style="justify-content: center; align-items: center">
                        <b-form-radio-group v-model="selectedOption" @change="updateIncludeVat">
                          <b-form-radio value="Yes">Yes</b-form-radio>
                          <b-form-radio value="No">No</b-form-radio>
                        </b-form-radio-group>
                      </b-col>
                    </b-row>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                  <VinputNumber
                      v-if="addData.priceOption === 'PerSquareMeter'"
                      inputType="number"
                      :modelValue="computedPrice"
                      @update:modelValue="
                        (newValue) => (computedPrice = newValue)
                      "
                      :rules="{}"
                      id="text-price"
                      name="text-price"
                      label="Monthly Price"
                      class="mb-1 mr-sm-2"
                      description="text-price-feedback"
                      validatorName="Monthly Price"
                      :step=".01"
                      disabled="disabled"
                    />
                   </b-col>
                    <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="addData.description"
                      @update:modelValue="
                        (newValue) => (addData.description = newValue)
                      "
                      :rules="{}"
                      id="text-description"
                      name="text-description"
                      label="Description"
                      class="mb-1 mr-sm-2"
                      description="text-description-feedback"
                      validatorName="Description"
                    />
                  </b-col>
                    <!-- <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                  <VinputNumber
                      inputType="number"
                      :modelValue="addData.electricPrice"
                      @update:modelValue="
                        (newValue) => (addData.electricPrice = newValue)
                      "
                      :rules="{  }"
                      id="text-electric-price"
                      name="text-electric-price"
                      label="Electric Bill"
                      class="mb-1 mr-sm-2"
                      description="text-electric-price-feedback"
                      validatorName="Electric Bill"
                      :step=".01"
                    />
                   </b-col>
                     <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                  <VinputNumber
                      inputType="number"
                      :modelValue="addData.waterPrice"
                      @update:modelValue="
                        (newValue) => (addData.waterPrice = newValue)
                      "
                      :rules="{}"
                      id="text-water-price"
                      name="text-water-price"
                      label="Water Bill"
                      class="mb-1 mr-sm-2"
                      description="text-water-price-feedback"
                      validatorName="Water Bill"
                      :step=".01"
                    />
                   </b-col>
                     <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                  <VinputNumber
                      inputType="number"
                      :modelValue="addData.parkingPrice"
                      @update:modelValue="
                        (newValue) => (addData.parkingPrice = newValue)
                      "
                      :rules="{}"
                      id="text-parking-price"
                      name="text-parking-price"
                      label="Parking Charges"
                      class="mb-1 mr-sm-2"
                      description="text-parking-price-feedback"
                      validatorName="Parking Charges"
                      :step=".01"
                    />
                   </b-col>
                    <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                  <VinputNumber
                      inputType="number"
                      :modelValue="addData.internetPrice"
                      @update:modelValue="
                        (newValue) => (addData.internetPrice = newValue)
                      "
                      :rules="{}"
                      id="text-internet-price"
                      name="text-internet-price"
                      label="Internet Cost"
                      class="mb-1 mr-sm-2"
                      description="text-internet-price-feedback"
                      validatorName="Internet Cost"
                      :step=".01"
                    />
                   </b-col>
                    <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                  <VinputNumber
                      inputType="number"
                      :modelValue="addData.otherPrice"
                      @update:modelValue="
                        (newValue) => (addData.otherPrice = newValue)
                      "
                      :rules="{ }"
                      id="text-other-price"
                      name="text-other-price"
                      label="Other Bills"
                      class="mb-1 mr-sm-2"
                      description="text-internet-price-feedback"
                      validatorName="Other Bills"
                      :step=".01"
                    />
                   </b-col>
                  -->
                  <b-col class="mt-2">
                    <b-button type="submit" variant="primary">Submit</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-modal>
      </div>
      <div class="row">
        <b-modal
            id="modal-top-changePrice"
            hide-footer
            title="Change Price"
            content-class="shadow" 
          >
            <template #modal-header="{ close }">
              <h5>Change Price and Bills</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            <b-tabs small card v-model="activeTabIndex">
              <b-tab v-if="!showBillsOnly">
                <template #title>
                  <span style="color: rgb(37, 91, 48) !important; font-size: 15px !important; font-weight: 600 !important;">
                     <span class="mob-title">Change Rent Price</span>
                  </span>
                </template>
                <validation-observer ref="observer" v-slot="{ handleSubmit }">
                  <b-form
                    class="text-left"
                    @submit.stop.prevent="handleSubmit(submitChangePriceForm)"
                  >
                    <b-row no-gutters>
                      <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="addData.priceOption"
                      @update:modelValue="
                        (newValue) => (addData.priceOption = newValue)
                      "
                        :options="priceOptions"
                      :rules="{ required: true }"
                      id="text-price-options"
                      name="text-price-options"
                      label="Price Options"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-price-options-feedback"
                      validatorName="Price Options"
                    />
                  </b-col>
                  <b-col
                        md="12"
                        style="justify-content: center; align-items: center"
                      >
                      <VinputNumber
                          v-if="addData.priceOption === 'PerSquareMeter'"
                          inputType="number"
                          :modelValue="computedPrice"
                          @update:modelValue="
                            (newValue) => (computedPrice = newValue)
                          "
                          :rules="{}"
                          id="text-price"
                          name="text-price"
                          label="Monthly Price"
                          class="mb-1 mr-sm-2"
                          description="text-price-feedback"
                          validatorName="Monthly Price"
                          :step=".01"
                          disabled="disabled"
                        />
                      </b-col>
                      <b-col
                        md="12"
                        style="justify-content: center; align-items: center"
                      >
                      <VinputNumber
                          inputType="number"
                          :modelValue="addData.price"
                          @update:modelValue="updatePrice"
                          :rules="{ required: true }"
                          id="text-price"
                          name="text-price"
                          label="Rent Price"
                          class="mb-1 mr-sm-2"
                          description="text-price-feedback"
                          validatorName="Price"
                          :step=".01"
                        />
                       <div v-if="errorMessage1" class="error-message">
                    {{errorMessage1}}
                    </div>
                  </b-col>
                      <b-col
                        md="12"
                        style="justify-content: center; align-items: center"
                      >
                        <Vinput
                          inputType="date"
                          :modelValue="addData.startDateRent"
                          @update:modelValue="
                            (newValue) => (addData.startDateRent = newValue)
                          "
                          :rules="{ required: true }"
                          id="text-startDate"
                          name="text-startDate"
                          label="Rent Start on"
                          class="mb-1 mr-sm-2"
                          description="text-startDate-feedback"
                          validatorName="Rent Start on"
                        />
                    </b-col>
                      <b-col class="mt-2">
                        <b-button type="submit" variant="primary">Submit</b-button>
                      </b-col>
                    </b-row>
                  </b-form>
                </validation-observer>
              </b-tab>
             <b-tab v-if="addData.billExist !== 'no'">
     <template #title>
       <span style="color: rgb(37, 91, 48); font-size: 15px; font-weight: 
600;">
         <span class="mob-title">Add Bills</span>
       </span>
     </template>

     <validation-observer ref="observer" v-slot="{ handleSubmit }">
       <b-form @submit.stop.prevent="handleSubmit(submitChangeBillForm)">
         <b-row no-gutters>
           <template v-if="isElectricBillVisible">
             <b-col md="12" class="d-flex align-items-center mb-3">
               <VinputNumber
                 inputType="number"
                 :modelValue="addData.electricPrice"
                 @update:modelValue="electricReading"
                 :rules="{ required: true }"
                 id="text-electric-reading"
                 name="text-electric-reading"
                 :label="electricBillLabel"
                 class="mb-1 mr-sm-2"
                 description="text-electric-reading-feedback"
                 validatorName="Electric Bill"
                 :step=".01"
               />
               <div v-if="errorElectric" class="error-message">{{ errorElectric }}</div>
             </b-col>
           </template>
           <template v-if="isWaterBillVisible">
             <b-col md="12" class="d-flex align-items-center mb-3">
               <VinputNumber
                 inputType="number"
                 :modelValue="addData.waterPrice"
                 @update:modelValue="waterReading"
                 :rules="{ required: true }"
                 id="text-water-reading"
                 name="text-water-reading"
                 :label="waterBillLabel"
                 class="mb-1 mr-sm-2"
                 description="text-water-reading-feedback"
                 validatorName="Water Bill"
                 :step=".01"
               />
               <div v-if="errorWater" class="error-message">{{ errorWater }}</div>
             </b-col>
           </template>
           <b-col md="12" class="d-flex align-items-center mb-3">
             <VinputNumber
               inputType="number"
               :modelValue="addData.parkingPrice"
               @update:modelValue="parkingBillPrice"
               :rules="{ required: true }"
               id="text-parking-price"
               name="text-parking-price"
               label="Parking Charges"
               class="mb-1 mr-sm-2"
               description="text-parking-price-feedback"
               validatorName="Parking Charges"
               :step=".01"
             />
             <div v-if="errorParking" class="error-message">{{ errorParking }}</div>
           </b-col>
          <b-col md="12" class="d-flex align-items-center mb-3">
             <VinputNumber
               inputType="number"
               :modelValue="addData.internetPrice"
               @update:modelValue="internetBillPrice"
               :rules="{ required: true }"
               id="text-internet-price"
               name="text-internet-price"
               label="Internet Cost"
               class="mb-1 mr-sm-2"
               description="text-internet-price-feedback"
               validatorName="Internet Cost"
               :step=".01"
             />
             <div v-if="errorInternet" class="error-message">{{ errorInternet }}</div>
           </b-col>
           <b-col md="12" class="d-flex align-items-center mb-3">
             <VinputNumber
               inputType="number"
               :modelValue="addData.otherPrice"
               @update:modelValue="otherBillPrice"
               :rules="{ required: true }"
               id="text-other-price"
               name="text-other-price"
               label="Other Bills"
               class="mb-1 mr-sm-2"
               description="text-internet-price-feedback"
               validatorName="Other Bills"
               :step=".01"
             />
             <div v-if="errorOther" class="error-message">{{ errorOther }}</div>
           </b-col>

           <template v-if="!isBillAmountOptionBySQMOrEqual">
             <b-col md="12" class="d-flex align-items-center mb-3">
               <Vinput
                 inputType="date"
                 :modelValue="addData.startDate"
                 @update:modelValue="(newValue) => (addData.startDate = newValue)"
                 :rules="{ required: true }"
                 id="text-startDate"
                 name="text-startDate"
                 label="Bill Start on"
                 class="mb-1 mr-sm-2"
                 description="text-startDate-feedback"
                 validatorName="Bill Start on"
               />
             </b-col>
                    </template>
                      <b-col class="mt-2">
                        <b-button type="submit" variant="primary">Submit</b-button>
                      </b-col>
                    </b-row>
                  </b-form>
                </validation-observer>
              </b-tab>
            </b-tabs>
          </b-modal>
      </div>
      <div class="row">
        <b-modal
            id="modal-top-changeBills"
            hide-footer
            title="Change Bills"
            content-class="shadow" 
          >
            <template #modal-header="{ close }">
              <h5>Change Bills</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <b-form
                class="text-left"
                @submit.stop.prevent="handleSubmit(submitChangeBillForm)"
              >
                <b-row no-gutters>
                    <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                  <VinputNumber
                      inputType="number"
                      :modelValue="addData.electricPrice"
                      @update:modelValue="
                        (newValue) => (addData.electricPrice = newValue)
                      "
                      :rules="{  }"
                      id="text-electric-price"
                      name="text-electric-price"
                      label="Electric Bill"
                      class="mb-1 mr-sm-2"
                      description="text-electric-price-feedback"
                      validatorName="Electric Bill"
                      :step=".01"
                    />
                   </b-col>
                     <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                  <VinputNumber
                      inputType="number"
                      :modelValue="addData.waterPrice"
                      @update:modelValue="
                        (newValue) => (addData.waterPrice = newValue)
                      "
                      :rules="{}"
                      id="text-water-price"
                      name="text-water-price"
                      label="Water Bill"
                      class="mb-1 mr-sm-2"
                      description="text-water-price-feedback"
                      validatorName="Water Bill"
                      :step=".01"
                    />
                   </b-col>
                     <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                  <VinputNumber
                      inputType="number"
                      :modelValue="addData.parkingPrice"
                      @update:modelValue="
                        (newValue) => (addData.parkingPrice = newValue)
                      "
                      :rules="{}"
                      id="text-parking-price"
                      name="text-parking-price"
                      label="Parking Charges"
                      class="mb-1 mr-sm-2"
                      description="text-parking-price-feedback"
                      validatorName="Parking Charges"
                      :step=".01"
                    />
                   </b-col>
                    <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                  <VinputNumber
                      inputType="number"
                      :modelValue="addData.internetPrice"
                      @update:modelValue="
                        (newValue) => (addData.internetPrice = newValue)
                      "
                      :rules="{}"
                      id="text-internet-price"
                      name="text-internet-price"
                      label="Internet Cost"
                      class="mb-1 mr-sm-2"
                      description="text-internet-price-feedback"
                      validatorName="Internet Cost"
                      :step=".01"
                    />
                   </b-col>
                    <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                  <VinputNumber
                      inputType="number"
                      :modelValue="addData.otherPrice"
                      @update:modelValue="
                        (newValue) => (addData.otherPrice = newValue)
                      "
                      :rules="{ }"
                      id="text-other-price"
                      name="text-other-price"
                      label="Other Bills"
                      class="mb-1 mr-sm-2"
                      description="text-internet-price-feedback"
                      validatorName="Other Bills"
                      :step=".01"
                    />
                   </b-col>
                  <b-col class="mt-2">
                    <b-button type="submit" variant="primary">Submit</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-modal>
      </div>
  <div class="row">
         <b-modal
             id="modal-top-EditHouse"
             hide-footer
             title="Edit House"
             content-class="shadow"
           >
             <template #modal-header="{ close }">
               <h5>Edit House</h5>
               <p class="h5 mb-2">
                 <b-icon
                   icon="x-square"
                   class="close-icon"
                   @click="
                     close();
                     clearData();
                   "
                 ></b-icon>
               </p>
             </template>
             <validation-observer ref="observer" v-slot="{ handleSubmit 
}">
               <b-form
                 class="text-left"
                 @submit.stop.prevent="handleSubmit(submitEditForm)"
               >
                 <b-row no-gutters>
                    <b-col
                     md="12"
                     style="justify-content: center; align-items: center"
                   >
                      <Vselect
                       :modelValue="selectedHouse.building.buildingId"
                       @update:modelValue="
                         (newValue) => (selectedHouse.building.buildingId 
= newValue)
                       "
                         :options="buildingOptions"
                       :rules="{ required: true }"
                       id="text-building"
                       name="text-building"
                       label="Building"
                       class="mb-1 mr-sm-2 some-select"
                       description="text-building-feedback"
                       validatorName="Building"
                     />
                   </b-col>
       
                    <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <VinputNumber
                      inputType="number"
                      :modelValue="selectedHouse.size"
                      @update:modelValue="editSize"
                      :rules="{ required: true }"
                      id="text-size"
                      name="text-size"
                      label="Size"
                      class="mb-1 mr-sm-2"
                      description="text-size-feedback"
                      validatorName="Size"
                      :step=".01"
                    />
                    <div v-if="errorMessage" class="error-message">
                    {{errorMessage}}
                    </div>
                  </b-col>
                    <b-col
                     md="12"
                     style="justify-content: center; align-items: center"
                   >
                     <VinputNumber
                       inputType="text"
                       :modelValue="selectedHouse.floor"
                       @update:modelValue="
                         (newValue) => (selectedHouse.floor = newValue)
                       "
                       :rules="{}"
                       id="text-floor"
                       name="text-floor"
                       label="Floor"
                       class="mb-1 mr-sm-2"
                       description="text-floor-feedback"
                       validatorName="Floor"
                     />
                   </b-col>
                    <b-col
                     md="12"
                     style="justify-content: center; align-items: center"
                   >
                     <Vinput
                       inputType="text"
                       :modelValue="selectedHouse.roomNumber"
                       @update:modelValue="
                         (newValue) => (selectedHouse.roomNumber = 
newValue)
                       "
                       :rules="{ }"
                       id="text-roomNumber"
                       name="text-roomNumber"
                       label="Room Number"
                       class="mb-1 mr-sm-2"
                       description="text-roomNumber-feedback"
                       validatorName="Room Number"
                     />
                   </b-col>
                   <b-col
                     md="12"
                     style="justify-content: center; align-items: center"
                   >
                      <Vselect
                       :modelValue="selectedHouse.priceOption"
                       @update:modelValue="
                         (newValue) => (selectedHouse.priceOption = 
newValue)
                       "
                         :options="priceOptions"
                       :rules="{ required: true }"
                       id="text-price-options"
                       name="text-price-options"
                       label="Price Options"
                       class="mb-1 mr-sm-2 some-select"
                       description="text-price-options-feedback"
                       validatorName="Price Options"
                     />
                   </b-col>
                   <b-col
                     md="12"
                     style="justify-content: center; align-items: center"
                   >
                      <Vselect
                       :modelValue="selectedHouse.includeVat"
                       @update:modelValue="
                         (newValue) => (selectedHouse.includeVat = newValue)
                       "
                         :options="includeVatOptions"
                       :rules="{ required: true }"
                       id="text-price-options"
                       name="text-price-options"
                       label="Include Vat"
                       class="mb-1 mr-sm-2 some-select"
                       description="text-price-options-feedback"
                       validatorName="Include Vat"
                     />
                   </b-col> 
                   <b-col
                     md="12"
                     style="justify-content: center; align-items: center"
                   >
                      <Vselect
                       :modelValue="selectedHouse.rentCurrencyType"
                       @update:modelValue="
                         (newValue) => (selectedHouse.rentCurrencyType = 
newValue)
                       "
                         :options="rentCurrencyTypeOptions"
                       :rules="{ required: true }"
                       id="text-rent-currency-options"
                       name="text-rent-currency-options"
                       label="Rent Currency"
                       class="mb-1 mr-sm-2 some-select"
                       description="text-rent-currency-options-feedback"
                       validatorName="Rent Currency"
                     />
                   </b-col> 
                   <b-col
                     md="12"
                     style="justify-content: center; align-items: center"
                   >
                     <Vinput
                       inputType="text"
                       :modelValue="selectedHouse.description"
                       @update:modelValue="
                         (newValue) => (selectedHouse.description = 
newValue)
                       "
                       :rules="{ }"
                       id="text-description"
                       name="text-description"
                       label="Description"
                       class="mb-1 mr-sm-2"
                       description="text-description-feedback"
                       validatorName="Description"
                     />
                   </b-col>
                   <b-col class="mt-2">
                     <b-button type="submit" 
                      variant="primary">Submit</b-button>
                   </b-col>
                 </b-row>
               </b-form>
             </validation-observer>
           </b-modal>
       </div>
      <div class="row">
        <b-modal
            id="modal-top-Details"
            hide-footer
            title="Details"
            content-class="shadow" 
            size="xl"
          >
            <template #modal-header="{ close }">
              <h5>Detail</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            <b-row>
              <b-col md="12">
               <b-table-simple
                 :small="true"
                  sticky-header
                  style="max-height: 395px;"
                  striped
                  responsive="sm"
                  hover
                  bordered
                >
                  <b-thead>
                    <b-tr>
                      <b-th colspan="7" style="font-weight: 700;text-align: center !important;">Building Information</b-th>
                    </b-tr>
                      <b-tr style="font-weight: 700;text-align: center !important;">
                      <b-th style="width: 20%">Building Name</b-th>
                      <b-th style="width: 10%">Floor</b-th>
                      <b-th style="width: 10%">Room Number</b-th>
                      <b-th style="width: 15%">Size</b-th>
                      <b-th style="width: 15%">Price Option</b-th>
                      <b-th style="width: 15%">Description</b-th>
                      <b-th style="width: 10%">Status</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr>
                      <b-td>{{selectedHouse.HouseInformation.BuildingName}}</b-td>
                      <b-td>{{selectedHouse.HouseInformation.floor}}</b-td>
                      <b-td>{{selectedHouse.HouseInformation.roomNumber}}</b-td>
                      <b-td>{{selectedHouse.HouseInformation.size}}</b-td>
                      <b-td>{{getOptionPrice(selectedHouse.HouseInformation.priceOption)}}</b-td>
                      <b-td>{{selectedHouse.HouseInformation.description}}</b-td>
                      <b-td>{{getStatus(selectedHouse.HouseInformation.status)}}</b-td>
                    </b-tr>
                  </b-tbody>
               </b-table-simple>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6" v-if="selectedHouse.ContractInformation.length > 0">
                <b-table-simple
                    :small="true"
                    sticky-header
                    style="max-height: 395px;"
                    striped
                    responsive="sm"
                    hover
                    bordered
                  >
                    <b-thead>
                      <b-tr>
                          <b-th colspan="7" style="font-weight: 700;text-align: center !important;">Contracts</b-th>
                      </b-tr>
                      <b-tr>
                        <b-th></b-th>
                        <b-th>Contract ID</b-th>
                        <b-th>Tenant</b-th>
                        <b-th>Tenant Phone No</b-th>
                        <b-th>From</b-th>
                        <b-th>To</b-th>
                        <b-th>Total Payment Recieved</b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr
                        v-for="(contract, index) in selectedHouse.ContractInformation"
                        :key="index"
                      >
                        <b-td>
                          <b-badge v-if="contract.Status == 1" variant="primary">Current</b-badge>
                        </b-td>
                        <b-td>{{contract.contractId}}</b-td>
                        <b-td>{{contract.TenantFullName}}</b-td>
                        <b-td>{{contract.TenantPhoneNumber}}</b-td>
                        <b-td>{{contract.ContractStartDate}}</b-td>
                        <b-td>{{contract.ContractEndDate}}</b-td>
                        <b-td>{{contract.TotalAmountForThisContract}}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-td colspan="6" style="font-weight: 700;text-align: right !important;">Total</b-td>
                        <b-td style="font-weight: 700;">{{selectedHouse.TotalAmountForHouse}}</b-td>
                      </b-tr>
                    </b-tbody>
                </b-table-simple>
              </b-col>
              <b-col md="6">
               <b-table-simple
                  :small="true"
                  sticky-header
                  style="max-height: 395px;"
                  striped
                  responsive="sm"
                  hover
                  bordered
                >
                  <b-thead>
                     <b-tr>
                        <b-th colspan="5" style="font-weight: 700;text-align: center !important;">Price Information</b-th>
                     </b-tr>
                    <b-tr>
                      <b-th style="width: 5%"></b-th>
                      <b-th style="width: 15%">Price Options</b-th>
                      <b-th style="width: 12%">Price</b-th>
                      <b-th style="width: 12%">Created At</b-th>
                      <b-th style="width: 15%">Changed By</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr
                      v-for="(item, index) in selectedHouse.PriceInformation"
                      :key="index"
                    >
                      <b-td>
                         <b-badge v-if="item.Status == 1" variant="primary">Current</b-badge>
                      </b-td>
                      <b-td>{{item.priceOption}}</b-td>
                      <b-td>{{numberWithCommas(item.Price)}}</b-td>
                      <b-td>{{item.CreatedDate}}</b-td>
                      <b-td>{{item.registeredBy}}</b-td>
                    </b-tr>
                  </b-tbody>
               </b-table-simple>
              </b-col>
            </b-row>
             <b-row>
              <b-col md="8" v-if="selectedHouse.houseProperty.length > 0">
                <b-table-simple
                    :small="true"
                    sticky-header
                    style="max-height: 395px;"
                    striped
                    responsive="sm"
                    hover
                    bordered
                  >
                    <b-thead>
                      <b-tr>
                          <b-th colspan="4" style="font-weight: 700;text-align: center !important;">House Property</b-th>
                      </b-tr>
                      <b-tr>
                        <b-th style="width: 12%">Property Name</b-th>
                        <b-th style="width: 12%">Property Status</b-th>
                        <b-th style="width: 12%">Created At</b-th>
                        <b-th>Changed By</b-th>
                        
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr
                        v-for="(property, index) in selectedHouse.houseProperty"
                        :key="index"
                      >
                        <b-td>{{property.propertyName}}</b-td>
                        <b-td>{{property.status}}</b-td>
                        <b-td>{{property.createdDate}}</b-td>
                        <b-td>{{property.createdBy}}</b-td>
                        <b-td>
                        <b-icon v-if="modulePermission.update == 1" icon="pencil-square" class="btn-icon" @click="EditProperty(property.id)"></b-icon>
                        </b-td>
                      </b-tr>
                    </b-tbody>
                </b-table-simple>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="8" v-if="selectedHouse.OtherPriceInformation.length > 0">
                <b-table-simple
                    :small="true"
                    sticky-header
                    style="max-height: 395px;"
                    striped
                    responsive="sm"
                    hover
                    bordered
                  >
                    <b-thead>
                      <b-tr>
                          <b-th colspan="10" style="font-weight: 700;text-align: center !important;">Other Bills</b-th>
                      </b-tr>
                      <b-tr>
                        <b-th style="width: 5%"></b-th>
                        <b-th style="width: 12%">Electric Bill</b-th>
                        <b-th style="width: 12%">Water Bill</b-th>
                        <b-th style="width: 15%">Parking Charges</b-th>
                        <b-th style="width: 12%">Internet Cost</b-th>
                        <b-th style="width: 12%">Other Bills</b-th>
                        <b-th style="width: 12%">Payment Status</b-th>
                        <b-th>Bill Starts On</b-th>
                        <b-th style="width: 12%">Created At</b-th>
                        <b-th>Changed By</b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr
                        v-for="(other, index) in selectedHouse.OtherPriceInformation"
                        :key="index"
                      >
                        <b-td>
                          <b-badge v-if="other.Status == 1" variant="primary">Current</b-badge>
                        </b-td>
                        <b-td>{{other.electricPrice}}</b-td>
                        <b-td>{{other.waterPrice}}</b-td>
                        <b-td>{{other.parkingPrice}}</b-td>
                        <b-td>{{other.internetPrice}}</b-td>
                        <b-td>{{other.otherPrice}}</b-td>
                        <b-td>
                          <b-badge :variant="other.paymentStatus === 'Paid' ? 'success' : other.paymentStatus === 'Pending' ? 'warning' : 'danger'">{{other.paymentStatus}}</b-badge>
                        </b-td>
                        <b-td>{{other.billStartsOn}}</b-td>
                        <b-td>{{other.CreatedDate}}</b-td>
                        <b-td>{{other.registeredBy}}</b-td>
                      </b-tr>
                    </b-tbody>
                </b-table-simple>
              </b-col>
            </b-row>
            <b-row v-if="selectedHouse.OtherPriceInformation && selectedHouse.OtherPriceInformation.length > 0">
              <b-col md="6">
                <b-table-simple
                  :small="true"
                  striped
                  responsive="sm"
                  hover
                  bordered
                >
                  <b-thead>
                    <b-tr>
                      <b-th colspan="2" style="font-weight: 700;text-align: center !important;">Bill Summary</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr>
                      <b-td style="font-weight: 600;">Total Unpaid Bills</b-td>
                      <b-td style="font-weight: 700; color: #dc3545;">{{numberWithCommas(getTotalUnpaidBills())}}</b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </b-col>
            </b-row>
        </b-modal>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <card class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
          >
             <template slot="header">
              <b-row>
              <b-col lg="8" class="my-1">
                <b-button v-if="modulePermission.create == 1" @click="AddHouse()" class="btn-outline-primary" v-b-tooltip.hover title="Add New House">
                  <b-icon class="text-center" icon="plus"></b-icon> New House
                </b-button>
              </b-col>
             <b-col lg="4" class="my-1">
                  <b-form-group class="mb-0">
                    <b-input-group size="sm">
                      <b-form-input
                        id="filter-input"
                        v-model="filter"
                        type="search"
                        placeholder="Filter"
                      ></b-form-input>

                      <b-input-group-append>
                        <b-button class="btn-secondary" :disabled="!filter" @click="filter = ''" v-b-tooltip.hover title="Clear Filter"
                          >Clear</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
            <b-table-simple
              :small="true"
              sticky-header
              style="max-height: 395px;"
              striped
              responsive="sm"
              hover
            >
              <b-thead>
                <b-tr>
                  <b-th>No.</b-th>
                  <b-th>Building Name</b-th>
                  <b-th>Floor</b-th>
                  <b-th>Room Number</b-th>
                  <b-th>Size</b-th>
                  <b-th>Price Option</b-th>
                  <b-th>S.Q.M price</b-th>
                  <b-th>Monthly Price</b-th>
                  <b-th>Other Bills</b-th>
                  <b-th>Status</b-th>
                  
                  <!-- <b-th v-if="mainRole === 'OWNER'">Price Option</b-th>
                  <b-th v-if="mainRole === 'OWNER'">S.Q.M price</b-th>
                  <b-th v-if="mainRole === 'OWNER'">Monthly Price</b-th>
                  <b-th v-if="mainRole === 'OWNER'">Other Bills</b-th>
                  <b-th v-if="mainRole === 'OWNER'">Status</b-th> -->
                  <b-th>Created At</b-th>
                  <b-th>Created By</b-th>
                  <b-th>Actions</b-th>
                </b-tr>
              </b-thead>
                 <template v-if="spinner">
                  <b-tbody class="text-center">
                    <b-tr >
                        <b-td colspan="11" class="text-center" style="display: table-cell">
                          <b-spinner
                          style="height: 3rem; width: 3rem;"
                            variant="warning"
                          ></b-spinner>
                        </b-td>
                      </b-tr>
                  </b-tbody>
                </template>
                <template v-else>
                  <template v-if="filterTable.length === 0">
                  <b-tbody class="text-center">
                      <b-tr>
                        <b-td colspan="13" class="text-center">Nothing found</b-td>
                        <b-td>-</b-td>
                      </b-tr>
                  </b-tbody>
                  </template>
                  <template v-else>
                     <b-tbody class="text-center">
                  <b-tr
                    v-for="(item, index) in filterTable"
                    :key="item.houseId"
                  >
                      <b-td>{{(currentPage - 1) * perPage + index + 1}}</b-td>
                      <b-td>{{item.building.buildingName}}</b-td>
                      <b-td>{{item.floor}}</b-td>
                      <b-td>{{item.roomNumber}}</b-td>
                      <b-td>{{item.size}} S.q.m</b-td>
                      <b-td>{{getOptionPrice(item.priceOption)}}</b-td>
                      <b-td>
                       <template v-if="item.priceOption === 'PerSquareMeter'">
                        {{numberWithCommas(item.latestPrice)}}
                        </template>
                         <template v-else>
                          Fixed Price
                        </template>
                      </b-td>
                      <b-td>
                        <template v-if="item.priceOption === 'PerSquareMeter'">
                        {{numberWithCommas(item.latestPrice * item.size)}}
                        </template>
                        <template v-else>
                          {{numberWithCommas(item.latestPrice)}}
                        </template>
                      </b-td>
                      <b-td>{{numberWithCommas(item.otherPrice)}}</b-td>
                      <b-td>{{item.status}}</b-td>
                      <b-td>{{item.createdDate}}</b-td>
                       <b-td>{{item.registeredBy}}</b-td>
                      <b-td>
                        <b-icon icon="eye-fill" class="btn-icon mr-2" @click="ViewDetail(item.houseId)" v-b-tooltip.hover title="View Details"></b-icon>
                        <b-icon v-if="modulePermission.update == 1" icon="pencil-square" class="btn-icon mr-2" @click="EditHouse(item.houseId)" v-b-tooltip.hover title="Edit House"></b-icon>
                        <b-icon v-if="modulePermission.update == 1 && mainRole === 'OWNER'" icon="currency-dollar" class="btn-icon mr-2" @click="ChangePrice(item.houseId)" v-b-tooltip.hover title="Change Price & Bills"></b-icon>
                        <b-icon v-if="modulePermission.update == 1 && mainRole === 'OWNER'" icon="receipt" class="btn-icon mr-2" @click="ViewBills(item.houseId)" v-b-tooltip.hover title="View Bills"></b-icon>
                        <b-icon v-if="modulePermission.update == 1 && mainRole === 'OWNER'" icon="house-door-fill" class="btn-icon" @click="AddProperty(item.houseId)" v-b-tooltip.hover title="Add Property"></b-icon>
                      </b-td>
                  </b-tr>
                     </b-tbody>
                  </template>
                </template>
            </b-table-simple>
            <b-row>
                <b-col md="3">
                  <b-form-group
                    id="fieldset-horizontal"
                    label-cols="8" label-cols-xs="8" label-size="md"
                    label="records per page"
                    label-for="input-horizontal"
                    label-align-xl="right"  
                  >
                  <b-form-select id="input-horizontal" v-model="perPage" :options="pageOptions" @change="changePerPage"></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="9">
                  <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalRows" @page-click="changePage" align="right"></b-pagination>
                </b-col>
            </b-row>
            </card>
        </div>
      </div>
       <div class="row">
        <b-modal
            id="modal-top-AddProperty"
            hide-footer
            title="Add Properties"
            content-class="shadow" 
          >
            <template #modal-header="{ close }">
              <h5>Add Properties</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <b-form
                class="text-left"
                @submit.stop.prevent="handleSubmit(submitAddPropertyForm)"
              >
                <b-row no-gutters>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="addProperties.propertyName"
                      @update:modelValue="
                        (newValue) => (addProperties.propertyName = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-propertyName"
                      name="text-propertyName"
                      label="Property Name"
                      class="mb-1 mr-sm-2"
                      description="text-propertyName-feedback"
                      validatorName="Property Name"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="addProperties.status"
                      @update:modelValue="
                        (newValue) => (addProperties.status = newValue)
                      "
                      :options="propertyStatusOptions"
                      :rules="{ required: true }"
                      id="text-propertyStatusOptions-options"
                      name="text-propertyStatusOptions-options"
                      label="Property Status"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-propertyStatusOptions-options-feedback"
                      validatorName="Property Status"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                    v-if="addProperties.status === 'Other'"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="addProperties.otherStatus"
                      @update:modelValue="
                        (newValue) => (addProperties.otherStatus = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-otherStatus"
                      name="text-otherStatus"
                      label="Other Status"
                      class="mb-1 mr-sm-2"
                      description="text-otherStatus-feedback"
                      validatorName="Other Status"
                    />
                  </b-col>
                  <b-col class="mt-2">
                    <b-button type="submit" variant="primary">Submit</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-modal>
      </div>
<div class="row">
   <b-modal id="edit-property-modal" hide-footer title="Edit Properties" 
content-class="shadow">
     <template #modal-header="{ close }">
       <h5>Edit Properties</h5>
       <p class="h5 mb-2">
         <b-icon icon="x-square" class="close-icon" @click="close(); clearData();"></b-icon>
       </p>
     </template>
     <validation-observer ref="observer" v-slot="{ handleSubmit }">
       <b-form
@submit.stop.prevent="handleSubmit(submitUpdatePropertyForm)">
         <b-row no-gutters>
           <b-col md="12">
             <Vinput
               inputType="text"
               :modelValue="selectedProperty.propertyName"
               @update:modelValue="(newValue) => (selectedProperty.propertyName = newValue)"
               :rules="{ required: true }"
               label="Property Name"
             />
           </b-col>
           <b-col md="12">
             <Vselect
               :modelValue="selectedProperty.status"
               @update:modelValue="(newValue) => (selectedProperty.status = newValue)"
               :options="propertyStatusOptions"
               :rules="{ required: true }"
               label="Property Status"
             />
           </b-col>
           <b-col md="12" v-if="selectedProperty.status === 'Other'">
             <Vinput
               inputType="text"
               :modelValue="selectedProperty.otherStatus"
               @update:modelValue="(newValue) => (selectedProperty.otherStatus = newValue)"
               :rules="{ required: true }"
               label="Other Status"
             />
           </b-col>
           <b-col class="mt-2">
             <b-button type="submit" variant="primary">Submit</b-button>
           </b-col>
         </b-row>
       </b-form>
     </validation-observer>
   </b-modal>
</div>

<div class="row">
  <b-modal
    id="modal-bills-list"
    hide-footer
    title="Bills List"
    content-class="shadow"
    size="xl"
  >
    <template #modal-header="{ close }">
      <h5>Bills List</h5>
      <div class="d-flex justify-content-between align-items-center">
        <b-button variant="primary" @click="ChangeBillsFromModal()" v-b-tooltip.hover title="Add New Bills">
          <b-icon icon="receipt"></b-icon> Add Bills
        </b-button>
        <b-icon
          icon="x-square"
          class="close-icon"
          @click="close();"
        ></b-icon>
      </div>
    </template>
    <b-table-simple
      :small="true"
      sticky-header
      style="max-height: 500px;"
      striped
      responsive="sm"
      hover
    >
      <b-thead>
        <b-tr>
          <b-th>Building</b-th>
          <b-th>Room</b-th>
          <b-th>Start Date</b-th>
          <b-th>Electric Reading</b-th>
          <b-th>Water Reading</b-th>
          <b-th>Electric Price</b-th>
          <b-th>Water Price</b-th>
          <b-th>Parking</b-th>
          <b-th>Internet</b-th>
          <b-th>Other</b-th>
          <b-th>Payment Status</b-th>
          <b-th>Actions</b-th>
        </b-tr>
      </b-thead>
      <b-tbody v-if="billsSpinner">
        <b-tr>
          <b-td colspan="12" class="text-center">
            <b-spinner variant="warning"></b-spinner>
          </b-td>
        </b-tr>
      </b-tbody>
      <b-tbody v-else-if="billsList.length === 0">
        <b-tr>
          <b-td colspan="12" class="text-center">No bills found</b-td>
        </b-tr>
      </b-tbody>
      <b-tbody v-else>
        <b-tr v-for="(bill, index) in billsList" :key="index">
          <b-td>{{ bill.building }}</b-td>
          <b-td>{{ bill.roomNumber }}</b-td>
          <b-td>{{ bill.startDate }}</b-td>
          <b-td>{{ bill.electricReading || 0 }}</b-td>
          <b-td>{{ bill.waterReading || 0 }}</b-td>
          <b-td>{{ numberWithCommas(bill.electricPrice || 0) }}</b-td>
          <b-td>{{ numberWithCommas(bill.waterPrice || 0) }}</b-td>
          <b-td>{{ numberWithCommas(bill.parkingPrice || 0) }}</b-td>
          <b-td>{{ numberWithCommas(bill.internetPrice || 0) }}</b-td>
          <b-td>{{ numberWithCommas(bill.otherPrice || 0) }}</b-td>
          <b-td>
            <b-badge :variant="bill.paymentStatus === 'Paid' ? 'success' : bill.paymentStatus === 'Pending' ? 'warning' : 'danger'">
              {{ bill.paymentStatus || 'N/A' }}
            </b-badge>
          </b-td>
          <b-td>
            <b-icon v-if="bill.paymentStatus === 'Unpaid' || bill.paymentStatus === 'Pending'" icon="pencil-square" class="btn-icon" @click="EditBill(bill)" v-b-tooltip.hover title="Edit Bill"></b-icon>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </b-modal>
</div>

<div class="row">
  <b-modal
    id="modal-edit-bill"
    hide-footer
    title="Edit Bill"
    content-class="shadow"
  >
    <template #modal-header="{ close }">
      <h5>Edit Bill</h5>
      <p class="h5 mb-2">
        <b-icon
          icon="x-square"
          class="close-icon"
          @click="close(); clearEditBillData();"
        ></b-icon>
      </p>
    </template>
    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <b-form @submit.stop.prevent="handleSubmit(submitEditBillForm)">
        <b-row no-gutters>
          <b-col md="12" class="mb-3">
            <VinputNumber
              inputType="number"
              :modelValue="editBillData.electricReading"
              @update:modelValue="(newValue) => (editBillData.electricReading = newValue)"
              :rules="{ required: true }"
              label="Electric Reading"
              :step=".01"
            />
          </b-col>
          <b-col md="12" class="mb-3">
            <VinputNumber
              inputType="number"
              :modelValue="editBillData.waterReading"
              @update:modelValue="(newValue) => (editBillData.waterReading = newValue)"
              :rules="{ required: true }"
              label="Water Reading"
              :step=".01"
            />
          </b-col>
          <b-col md="12" class="mb-3">
            <VinputNumber
              inputType="number"
              :modelValue="editBillData.parkingPrice"
              @update:modelValue="(newValue) => (editBillData.parkingPrice = newValue)"
              :rules="{ required: true }"
              label="Parking Price"
              :step=".01"
            />
          </b-col>
          <b-col md="12" class="mb-3">
            <VinputNumber
              inputType="number"
              :modelValue="editBillData.internetPrice"
              @update:modelValue="(newValue) => (editBillData.internetPrice = newValue)"
              :rules="{ required: true }"
              label="Internet Price"
              :step=".01"
            />
          </b-col>
          <b-col md="12" class="mb-3">
            <VinputNumber
              inputType="number"
              :modelValue="editBillData.otherPrice"
              @update:modelValue="(newValue) => (editBillData.otherPrice = newValue)"
              :rules="{ required: true }"
              label="Other Price"
              :step=".01"
            />
          </b-col>
          <b-col class="mt-2">
            <b-button type="submit" variant="primary">Update Bill</b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</div>


    </div>
  </div>
</template>
<script>
  import LTable from 'src/components/Table.vue'
  import Card from 'src/components/Cards/Card.vue'
  import Vinput from 'src/components/Inputs/Vinput.vue'
  import VinputNumber from 'src/components/Inputs/VinputNumber.vue'
  import Vselect from 'src/components/Inputs/Vselect.vue'
  export default {
    components: {
      LTable,
      Card,
      Vinput,
      VinputNumber,
      Vselect
    },
    data () {
      return {
      mainRole: sessionStorage.getItem("mainRole"),
      selectedProperty: {
       id: null,
       propertyName: '',
       status: '',
       otherStatus: '', // Include this if needed
     },
        modulePermission: {
          view: 1,
          create: 0,
          update: 0,
          delete: 0
        },
        totalRows: 0,
        currentPage: 1,
        pageOptions: [
          {value: 7, text: 7},
          {value: 10, text: 10},
          {value: 25, text: 25},
          {value: 50, text: 50},
          {value: 100, text: 100}
        ],
        perPage: 7,
        items: [],
        buildingOptions: [],
        priceOptions: [
          {value:"PerSquareMeter", text: "Per Square Meter"},
          {value:"PerMonth", text: "Monthly"}
        ],
        includeVatOptions: [
          {value:"Yes", text: "Yes"},
          {value:"No", text: "No"}
        ],
        rentCurrencyTypeOptions:[
          {value:"ETB", text:"ETB"},
          {value:"USD", text:"USD"}
        ],
        propertyStatusOptions: [
          {value:"Excellent", text: "Excellent"},
          {value:"Very Good", text: "Very Good"},
          {value:"Good", text: "Good"},
          {value:"Poor", text: "Poor"},
          {value:"Damaged", text: "Damaged"},
          {value: "Other", text: "Other"}
        ],
        errorMessage: '',
        errorMessage1: '',
        errorElectric: '',
        errorWater: '',
        errorParking: '',
        errorInternet: '',
        errorOther: '',
        activeTabIndex: 0,
        showBillsOnly: false,
        addData: {
          size: 0,
          floor : 0,
          roomNumber: "",
          buildingId: "",
          priceOption: "",
          electricPrice: 0,
          waterPrice: 0,
          parkingPrice: 0,
          internetPrice: 0,
          otherPrice: 0,
          price: 0,
          waterBillAmountOption: "",
          electricBillAmountOption: "",
          billExist:"",
          description: "",
          rentCurrencyType: "",
          registeredBy: "",
          createdBy: "",
          startDate: "",
          startDateRent:"",
          includeVat: null, 
        },
        selectedOption: "Yes", 
        numberRules: [
          v => !!v || 'Size is required',
          v => (v > 0) || 'Size must be greater than zero'
        ],
        yesSelected: false,
        noSelected: false,
        selectedHouse: {
          houseId: null,
          houses:[],
          houseOptions:[],
          HouseInformation: {
              floor: 0,
              roomNumber: "",
              registerDate: "",
              status: 0,
              size: "",
              latestPrice: "",
              BuildingName: "",
              includeVat: "",
              description: ""
          },
          ContractInformation: [
              // {
              //     TenantFullName: "",
              //     TenantPhoneNumber: "",
              //     ContractStartDate: "",
              //     ContractEndDate: "",
              //     InitialPayment: 0.0,
              //     Period: 0.0,
              //     TotalAmountForThisContract: 0.0
              // }
          ],
          TotalAmountForHouse: 0.0,
          PriceInformation: [
              // {
              //     Price: 300.0,
              //     CreatedDate: 2023-11-11,
              //     Status: 1
              // }
          ],
          priceChangedNumber: 0,
          OtherPriceInformation: [],
          houseProperty: []
        },
        filter: "",
        spinner: true,
        addProperties:{
          houseId: "",
          propertyName: "",
          status: "",
          otherStatus: "",
          createdBy: sessionStorage.getItem("userID")
        },
        billsList: [],
        billsSpinner: false,
        selectedBill: {
          houseId: null,
          startDate: '',
          electricReading: 0,
          waterReading: 0,
          electricBill: 0,
          waterBill: 0,
          parkingPrice: 0,
          internetPrice: 0,
          otherPrice: 0
        },
        editBillData: {
          houseId: null,
          startDate: '',
          electricReading: 0,
          waterReading: 0,
          electricBill: 0,
          waterBill: 0,
          parkingPrice: 0,
          internetPrice: 0,
          otherPrice: 0
        }
      }
    },
     mounted() {
      this.getModules();
      this.getBuildings();
      this.getHouseByOwnerID();
      this.$on("AfterComplete", () => {
        this.getBuildings();
        this.getHouseByOwnerID();
      });
    },
    computed: {
      isElectricBillVisible() {
       return this.addData.electricBillAmountOption === 'ByReading' || this.addData.electricBillAmountOption === 'ByAmountForEachHouse';
     },
     isWaterBillVisible() {
       return this.addData.waterBillAmountOption === 'ByReading' || this.addData.waterBillAmountOption === 'ByAmountForEachHouse';
     },
     isBillAmountOptionBySQMOrEqual() {
       return this.addData.billAmountOption === 'BySQM' || this.addData.billAmountOption === 'EqualForAllHouse';
     },
     electricBillLabel() {
       return this.addData.electricBillAmountOption === 'ByReading' ? 
       'CurrentElectric Reading (KWH)' : 'Electric Bill';
     },
     waterBillLabel() {
       return this.addData.waterBillAmountOption === 'ByReading' ? 'Current Water Reading (Meter Cube)' : 'Water Bill';
     },
      filterTable() {
        var searchItems = this.items;
        var searchString = this.filter;
        if (searchString === "") {
          return searchItems;
        }
        searchString = searchString.trim().toLowerCase();

        searchItems = searchItems.filter(function (item) {
          if (item.building.buildingName.toLowerCase().indexOf(searchString) !== -1 ||  String(item.floor).toLowerCase().indexOf(searchString) !== -1 || item.roomNumber.toLowerCase().indexOf(searchString) !== -1 || item.createdDate.toLowerCase().indexOf(searchString) !== -1 || item.registeredBy.toLowerCase().indexOf(searchString) !== -1 || item.status.toLowerCase().indexOf(searchString) !== -1) {
            return item;
          }
        });
        return searchItems;
      },
      computedPrice(){
        if(this.addData.priceOption == "PerSquareMeter"){
          if(this.addData.size !== null && this.addData.price !==null) return this.addData.size * this.addData.price;
          else return null
        }else{
          return null
        }
      }
    },
    methods: {
        EditProperty(ID) {
     console.log('Editing property with ID:', ID);
     if (!ID) {
       console.error('ID is null or undefined');
       return;
     }
     this.fetchPropertyData(ID);
   },

   fetchPropertyData(id) {
     this.$store.dispatch('getOneProperty', { id })
       .then(response => {
         console.log("Fetched property data:", response.data);
         const houseProperty = response.data;
         this.selectedProperty = houseProperty;
         this.addProperties = {
           propertyName: houseProperty.propertyName,
           status: houseProperty.status,
           otherStatus: houseProperty.otherStatus || '',
         };
         this.$bvModal.show('edit-property-modal');
       })
       .catch(error => {
         console.error('Error fetching property data:', error);
         this.$notifications.notify({
           message: 'Failed to fetch property data.',
           horizontalAlign: 'center',
           verticalAlign: 'top',
           type: 'danger'
         });
       });
   },

   submitUpdatePropertyForm() {
     this.$bvModal.msgBoxConfirm('Are you sure you want to submit this form?', {
       title: 'Confirm',
       size: 'sm',
       buttonSize: 'sm',
       okVariant: 'success',
       cancelVariant: 'danger',
       okTitle: 'YES',
       cancelTitle: 'NO',
       bodyClass: 'm-2',
       hideHeaderClose: false,
       centered: false
     })
     .then(value => {
       if (value === true) {
         if (!this.selectedProperty || !this.selectedProperty.id) {
           console.error('No selected property ID found for update.');
           return;
         }

         let propertyUpdate = {
           id: this.selectedProperty.id,
           propertyName: this.selectedProperty.propertyName,
           createdBy: parseInt(sessionStorage.getItem("userID"))
         };

         if (this.addProperties.otherStatus) {
           propertyUpdate.status = this.selectedProperty.otherStatus;
         } else {
           propertyUpdate.status = this.selectedProperty.status;
         }

         this.$store.dispatch('UpdateProperty', propertyUpdate)
           .then(response => {
             console.log("Updated property data:", propertyUpdate);
             console.log("response:", response);

             // Refresh the property list
            // this.ViewDetail();

             this.$notifications.notify({
               message: `The property was successfully updated.`,
               horizontalAlign: 'center',
               verticalAlign: 'top',
               type: 'success'
             });

             this.$bvModal.hide('edit-property-modal');
             this.clearData();
             this.getHouseByOwnerID();
             this.refreshSelectedHouseDetails();
           })
           .catch(error => {
             console.error(error);
             this.$notifications.notify({
               message: error.response.data,
               horizontalAlign: 'center',
               verticalAlign: 'top',
               type: 'danger'
             });
           });
       }
     })
     .catch(error => {
       console.error(error);
     });
   },

      updateSize(newValue){
        this.addData.size = newValue;
        this.validateSize(newValue);
      },
        editSize(newValue){
        this.selectedHouse.size = newValue;
        this.validateSize(newValue);
      },
        addPrice(newValue){
        this.addData.price = newValue;
        this.validateAmount(newValue);
      },
       updatePrice(newValue){
        this.addData.price = newValue;
        this.validateAmount(newValue);
      },
            electricReading(newValue) {
       this.addData.electricPrice = newValue;
       this.validateInput(newValue, 'Electric');
     },
     waterReading(newValue) {
       this.addData.waterPrice = newValue;
       this.validateInput(newValue, 'Water');
     },
     parkingBillPrice(newValue) {
       this.addData.parkingPrice = newValue;
       this.validateInput(newValue, 'Parking');
     },
     internetBillPrice(newValue) {
       this.addData.internetPrice = newValue;
       this.validateInput(newValue, 'Internet');
     },
     otherBillPrice(newValue) {
       this.addData.otherPrice = newValue;
       this.validateInput(newValue, 'Other');
     },
     validateInput(value, fieldName) {
       if (value === null || value === undefined || isNaN(value)) {
         this[`error${fieldName}`] = '';
       } else if (value < 0) {
         this[`error${fieldName}`] = 'Amount must be greater than or equal to zero';
       } else {
         this[`error${fieldName}`] = '';
       }
     },

      validateSize(value){
        if(value === null || value===undefined || isNaN(value)){
          this.errorMessage = '';
        }
        else if(value<= 0){
          this.errorMessage = 'Size must be greater than zero';
        }
        else{
          this.errorMessage = '';
        }
      },
       validateAmount(value){
        if(value === null || value===undefined || isNaN(value)){
          this.errorMessage1 = '';
        }
        else if(value<= 0){
          this.errorMessage1 = 'Amount must be greater than zero';
        }
        else{
          this.errorMessage1 = '';
        }
      },
      validateElectric(value){
        if(value === null || value===undefined || isNaN(value)){
          this.errorElectric = '';
        }
        else if(value < 0){
          this.errorElectric = 'Amount must be greater than zero';
        }
        else{
          this.errorElectric = '';
        }
      },
        validateWater(value){
        if(value === null || value===undefined || isNaN(value)){
          this.errorWater = '';
        }
        else if(value < 0){
          this.errorWater = 'Amount must be greater than zero';
        }
        else{
          this.errorWater = '';
        }
      },
      validateInternat(value){
        if(value === null || value===undefined || isNaN(value)){
          this.errorInternet = '';
        }
        else if(value< 0){
          this.errorInternet = 'Amount must be greater than or equal zero';
        }
        else{
          this.errorInternet = '';
        }
      },
       validateParking(value){
        if(value === null || value===undefined || isNaN(value)){
          this.errorParking = '';
        }
        else if(value< 0){
          this.errorParking = 'Amount must be greater than or equal zero';
        }
        else{
          this.errorParking = '';
        }
      },
       validateOther(value){
        if(value === null || value===undefined || isNaN(value)){
          this.errorOther = '';
        }
        else if(value< 0){
          this.errorOther = 'Amount must be greater than or equal zero';
        }
        else{
          this.errorOther = '';
        }
      },
      getModules(){
        this.$store.dispatch('getModulesPermission', {userId: sessionStorage.getItem("userID")})
          .then(response=>{
              //this.items = response.data;
              var modulesList = response.data.modules;
              var BuildingModule = modulesList.filter(x=>x.name === "House");
              if(BuildingModule !== null){
                this.modulePermission.view = BuildingModule[0].listData;
                this.modulePermission.create = BuildingModule[0].createData;
                this.modulePermission.update = BuildingModule[0].updateData;
                this.modulePermission.delete = BuildingModule[0].deleteData;
              }
          })
          .catch(error=>{
              console.log(error);
          })
      },
      getStatus(status){
        return status == 1 ? "Rented" : "Free";
      },
      numberWithCommas(x) {
        if(x !== null && x !== undefined){
            x = x.toFixed(2);
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
      },
      getBuildings(){
         this.$store.dispatch('getBuildingsByOwnerID',{userId: sessionStorage.getItem("ID")})
        .then(response=>{
            Array.from(response.data).forEach((value) => {
            this.buildingOptions.push({
              value: value.buildingId,
              text: value.buildingName
            });
          });
        })
        .catch(error=>{
            this.$notify({
                title: 'Error',
                text: error.response.data,
                type: 'error'
            })
        })
      },
      getHouseByOwnerID(){
          this.spinner = true;
          this.$store.dispatch('getHouseByOwnerID', {userId: sessionStorage.getItem("ID"), page: this.currentPage, line: this.perPage})
          .then(response=>{
              this.items = response.data.Contents;
              this.totalRows = response.data.totalElements;
             // console.log("item:", response.data)
          })
          .catch(error=>{
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
      },
      refreshSelectedHouseDetails() {
        if (!this.selectedHouse || !this.selectedHouse.houseId) {
          return;
        }

        const houseId = this.selectedHouse.houseId;
        this.$store.dispatch('GetHouseDetailById', { houseId })
          .then(response => {
            if (response && response.data) {
              const data = response.data;
              // Merge response into selectedHouse to preserve reactivity for nested properties
              Object.keys(data).forEach(key => {
                this.$set(this.selectedHouse, key, data[key]);
              });
            }
          })
          .catch(error => {
            console.warn('Unable to refresh selected house details:', error);
          });
      },
      changePage(event, page){
        this.spinner = true;
         this.$store.dispatch('getHouseByOwnerID', {userId: sessionStorage.getItem("ID"), page: page, line: this.perPage})
          .then(response=>{
              this.items = response.data.Contents;
              this.totalRows = response.data.totalElements;
             // console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
      },
       changePerPage(event){
          this.spinner = true;
         this.$store.dispatch('getHouseByOwnerID', {userId: sessionStorage.getItem("ID"), page: this.currentPage, line: this.perPage})
          .then(response=>{
              this.items = response.data.Contents;
              this.totalRows = response.data.totalElements;
             // console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
          .finally(msg=>{
            this.spinner =false;
          })
      },
      AddHouse(){
        this.$bvModal.show('modal-top-add');
      },
      submitAddForm(){
        this.$bvModal.msgBoxConfirm('Are you sure you want to submit this form?', {
              title: 'Confirm',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              cancelVariant: 'danger',
              okTitle: 'YES',
              cancelTitle: 'NO',
              bodyClass: 'm-2',
              hideHeaderClose: false,
              centered: false
          })
        .then(value => {
            if(value === true){
              console.log("this.addData", this.addData);
              this.$store.dispatch('AddHouse', {
                  floor: this.addData.floor,
                  roomNumber: this.addData.roomNumber,
                  size: this.addData.size,
                  buildingId: this.addData.buildingId,
                  price: this.addData.price,
                  priceOption: this.addData.priceOption,
                  rentCurrencyType:this.addData.rentCurrencyType,
                  description: this.addData.description,
                  includeVat: this.selectedOption,
                  registeredBy: parseInt(sessionStorage.getItem("userID"))
                })
              .then(response=>{
                  this.$notifications.notify(
                    {
                      message: `House successfully created.`,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'success'
                    })
                    this.$bvModal.hide('modal-top-add');
                    this.clearData();
                    this.getHouseByOwnerID();
              })
              .catch(error=>{
                  this.$notifications.notify(
                  {
                    message: error.response.data,
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                  })
              })
            }
        })
        .catch(error=>{
            console.log(error)
        })
      },
      ChangePrice(ID){
        this.showBillsOnly = false;
        this.activeTabIndex = 0;
        this.selectedHouse.houseId = ID;
        const house = this.items.filter(x=>x.houseId == ID)[0];
        this.addData.createdBy= sessionStorage.getItem("userID")
        // Set bill options from house data
        this.addData.electricBillAmountOption = house.electricBillAmountOption;
        this.addData.waterBillAmountOption = house.waterBillAmountOption;
        this.addData.billExist = house.building.billExist;
        
        // Set price data from house response
        this.addData.price = parseFloat(house.price || house.latestPrice) || 0;
        this.addData.priceOption = house.priceOption;
        this.addData.size = parseFloat(house.size) || 0;
        this.addData.startDate = house.startDate;
        this.addData.startDateRent = house.startDate;
        
        // Set bill reading data if available
        if (house.electricBillAmountOption === 'ByReading') {
          this.addData.electricPrice = parseFloat(house.newElectricReading) || 0;
        }
        if (house.waterBillAmountOption === 'ByReading') {
          this.addData.waterPrice = parseFloat(house.newWaterReading) || 0;
        }
        
        // Get current bills data
        this.$store.dispatch('getBillsByHouseIDStatus1', {houseId: ID})
          .then(response=>{
            if (response.data) {
              this.addData.parkingPrice = parseFloat(response.data.parkingPrice) || 0;
              this.addData.internetPrice = parseFloat(response.data.internetPrice) || 0;
              this.addData.otherPrice = parseFloat(response.data.otherPrice) || 0;
              if (!this.addData.startDate) {
                this.addData.startDate = response.data.startDate;
              }
            }
            this.$bvModal.show('modal-top-changePrice');
          })
          .catch(error=>{
            console.log("Bills error:", error);
            this.$bvModal.show('modal-top-changePrice');
          })
      },
      submitChangePriceForm(){
        this.$bvModal.msgBoxConfirm('Are you sure you want to change price of this form?', {
              title: 'Confirm',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              cancelVariant: 'danger',
              okTitle: 'YES',
              cancelTitle: 'NO',
              bodyClass: 'm-2',
              hideHeaderClose: false,
              centered: false
          })
        .then(value => {
            if(value === true){
              this.$store.dispatch('ChangePrice', {houseId: this.selectedHouse.houseId, price: this.addData.price, priceOption: this.addData.priceOption, startDate: this.addData.startDateRent, user:{id: sessionStorage.getItem("ID")},createdBy: sessionStorage.getItem("userID")})
              .then(response=>{
                  this.$notifications.notify(
                    {
                      message: `Price Successfully Updated.`,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'success'
                    })
                    this.$bvModal.hide('modal-top-changePrice');
                    this.clearData();
              })
              .catch(error=>{
                this.$notifications.notify(
                    {
                      message: error.response.data,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'danger'
                    })
                  console.log(error);
              })
            }
        })
        .catch(error=>{
            console.log(error)
        })
      },
      ChangeBillsPrice(ID){
        this.selectedHouse.houseId = ID;
        this.$store.dispatch('getHouseById', {houseId: ID})
          .then(response=>{
            console.log("some ", response.data)
              this.addData.electricBillAmountOption = response.data[0].electricBillAmountOption;
              this.addData.waterBillAmountOption = response.data[0].waterBillAmountOption;
              this.addData.billExist = response.data[0].building.billExist;
          })
          .catch(error=>{
              //this.$notify({
              //    title: 'Error',
              //    text: error.response.data,
              //    type: 'error'
             // })
              console.log("here: ",error);
          })
        this.$store.dispatch('getBillsByHouseIDStatus1', {houseId: ID})
          .then(response=>{
            this.addData.electricPrice = response.data[0].electricPrice;
              this.addData.waterPrice = response.data[0].waterPrice;
              this.addData.parkingPrice = response.data[0].parkingPrice;
              this.addData.internetPrice = response.data[0].internetPrice;
              this.addData.otherPrice = response.data[0].otherPrice;
              this.addData.startDate = response.data[0].startDate;
              this.$bvModal.show('modal-top-changeBills');
          })
          .catch(error=>{
              this.$notify({
                  title: 'Error',
                  text: error.response.data,
                  type: 'error'
              })
              // console.log(error);
          })
      },
      // submitChangeBillForm(){
      //   //console.log("some:this", this.addData);
      //   this.$bvModal.msgBoxConfirm('Are you sure you want to change bills ?', {
      //         title: 'Confirm',
      //         size: 'sm',
      //         buttonSize: 'sm',
      //         okVariant: 'success',
      //         cancelVariant: 'danger',
      //         okTitle: 'YES',
      //         cancelTitle: 'NO',
      //         bodyClass: 'm-2',
      //         hideHeaderClose: false,
      //         centered: false
      //     })
      //   .then(value => {
      //       if(value === true){
      //         if(this.addData.electricBillAmountOption === "ByReading" && this.addData.waterBillAmountOption === "ByReading"){
      //            this.$store.dispatch('ChangeBillsByReading', {user: {id:sessionStorage.getItem("userID")}, houseId: this.selectedHouse.houseId, userId: sessionStorage.getItem("userID"), electricReading: this.addData.electricPrice, waterReading: this.addData.waterPrice, parkingPrice: this.addData.parkingPrice, internetPrice: this.addData.internetPrice, otherPrice: this.addData.otherPrice, startDate:this.addData.startDate})
      //             .then(response=>{
      //                 this.$notifications.notify(
      //                   {
      //                     message: `Bills Successfully Updated.`,
      //                     horizontalAlign: 'center',
      //                     verticalAlign: 'top',
      //                     type: 'success'
      //                   })
      //                   this.$bvModal.hide('modal-top-changeBills');
      //                   this.$bvModal.hide('modal-top-changePrice');
      //                   this.clearData();
      //             })
      //             .catch(error=>{
      //               this.$notifications.notify(
      //                   {
      //                     message: error.response.data,
      //                     horizontalAlign: 'center',
      //                     verticalAlign: 'top',
      //                     type: 'danger'
      //                   })
      //                 console.log(error);
      //             })
      //         }else if((this.addData.electricBillAmountOption == "BySQM" || this.addData.electricBillAmountOption == "EqualForAllHouse")||(this.addData.electricBillAmountOption == "BySQM" || this.addData.electricBillAmountOption == "EqualForAllHouse")){
      //          // console.log("some")
      //           this.$store.dispatch('ChangeBillsOfInternetAndOther', {user:{id:sessionStorage.getItem("userID")}, houseId: this.selectedHouse.houseId, userId: sessionStorage.getItem("userID"), parkingPrice: this.addData.parkingPrice, internetPrice: this.addData.internetPrice, otherPrice: this.addData.otherPrice, startDate:this.addData.startDate})
      //           .then(response=>{
      //               this.$notifications.notify(
      //                 {
      //                   message: `Bills Successfully Updated.`,
      //                   horizontalAlign: 'center',
      //                   verticalAlign: 'top',
      //                   type: 'success'
      //                 })
      //                 this.$bvModal.hide('modal-top-changeBills');
      //                 this.$bvModal.hide('modal-top-changePrice');
      //                 this.clearData();
      //           })
      //           .catch(error=>{
      //             this.$notifications.notify(
      //                 {
      //                   message: error.response.data,
      //                   horizontalAlign: 'center',
      //                   verticalAlign: 'top',
      //                   type: 'danger'
      //                 })
      //               console.log(error);
      //           })
      //         }else{
      //           this.$store.dispatch('ChangeBills', {user:{id:sessionStorage.getItem("userID")}, house:{houseId: this.selectedHouse.houseId}, electricPrice: this.addData.electricPrice, waterPrice: this.addData.waterPrice, parkingPrice: this.addData.parkingPrice, internetPrice: this.addData.internetPrice, otherPrice: this.addData.otherPrice, startDate:this.addData.startDate})
      //           .then(response=>{
      //               this.$notifications.notify(
      //                 {
      //                   message: `Bills Successfully Updated.`,
      //                   horizontalAlign: 'center',
      //                   verticalAlign: 'top',
      //                   type: 'success'
      //                 })
      //                // console.log("repose:", response);
      //                 this.$bvModal.hide('modal-top-changeBills');
      //                 this.$bvModal.hide('modal-top-changePrice');
      //                 this.clearData();
      //           })
      //           .catch(error=>{
      //              console.log("repose:", error);
      //             this.$notifications.notify(
      //                 {
      //                   message: error.response.data,
      //                   horizontalAlign: 'center',
      //                   verticalAlign: 'top',
      //                   type: 'danger'
      //                 })
      //               console.log(error);
      //           })
      //         }
      //       }
      //   })
      //   .catch(error=>{
      //       console.log(error)
      //   })
      // },

     submitChangeBillForm() {
       this.$bvModal.msgBoxConfirm('Are you sure you want to change bills?', {
         title: 'Confirm',
         size: 'sm',
         buttonSize: 'sm',
         okVariant: 'success',
         cancelVariant: 'danger',
         okTitle: 'YES',
         cancelTitle: 'NO',
         bodyClass: 'm-2',
         hideHeaderClose: false,
         centered: false
       })
       .then(value => {
         if (value === true) {
           const billRequest = {
             houseId: this.selectedHouse.houseId,
             userId: parseInt(sessionStorage.getItem('ID')),
             createdBy: parseInt(sessionStorage.getItem('userID')),
             parkingPrice: this.addData.parkingPrice || 0,
             internetPrice: this.addData.internetPrice || 0,
             otherPrice: this.addData.otherPrice || 0,
             startDate: this.addData.startDate
           }

           // Add electric data based on billing mode
           if (this.addData.electricBillAmountOption === 'ByReading') {
             billRequest.electricReading = this.addData.electricPrice || 0
           } else if (this.addData.electricBillAmountOption === 'ByAmountForEachHouse') {
             billRequest.electricBill = this.addData.electricPrice || 0
           }

           // Add water data based on billing mode
           if (this.addData.waterBillAmountOption === 'ByReading') {
             billRequest.waterReading = this.addData.waterPrice || 0
           } else if (this.addData.waterBillAmountOption === 'ByAmountForEachHouse') {
             billRequest.waterBill = this.addData.waterPrice || 0
           }

           this.$store.dispatch('ChangeBillsByReading', billRequest)
             .then(response => {
               this.$notifications.notify({
                 message: 'Bills successfully updated.',
                 horizontalAlign: 'center',
                 verticalAlign: 'top',
                 type: 'success'
               })
               this.$bvModal.hide('modal-top-changeBills')
               this.$bvModal.hide('modal-top-changePrice')
               this.clearData()
               this.getHouseByOwnerID()
               this.refreshSelectedHouseDetails()
             })
             .catch(error => {
               this.$notifications.notify({
                 message: (error.response && error.response.data) || 'Failed to update bills.',
                 horizontalAlign: 'center',
                 verticalAlign: 'top',
                 type: 'danger'
               })
             })
         }
       })
       .catch(error => {
         console.error('Error in confirmation modal:', error)
       })
     },
      AddProperty(ID){
        this.selectedHouse = this.items.filter(item=> item.houseId == ID)[0];
        this.$bvModal.show('modal-top-AddProperty');
      },
      submitAddPropertyForm(){
        this.$bvModal.msgBoxConfirm('Are you sure you want to submit this form?', {
            title: 'Confirm',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'success',
            cancelVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            bodyClass: 'm-2',
            hideHeaderClose: false,
            centered: false
        })
        .then(value => {
            if(value === true){
              var JsonData = null;

              if(this.addProperties.otherStatus === "" ){
                JsonData = {
                  houseId: this.selectedHouse.houseId,
                  status: this.addProperties.status,
                  propertyName: this.addProperties.propertyName,
                  createdBy: parseInt(sessionStorage.getItem("userID"))
                }
              }else{
                JsonData = {
                  houseId: this.selectedHouse.houseId,
                  status: this.addProperties.otherStatus,
                  propertyName: this.addProperties.propertyName,
                  createdBy: parseInt(sessionStorage.getItem("userID"))
                }
              }

              this.$store.dispatch('AddProperty', JsonData)
              .then(response=>{
                  this.$notifications.notify(
                    {
                      message: `Property registered successfully.`,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'success'
                    })
                    this.$bvModal.hide('modal-top-AddProperty');
                    this.clearData();
                    this.getHouseByOwnerID();
                    this.refreshSelectedHouseDetails();
              })
              .catch(error=>{
                console.log(error);
                this.$notifications.notify(
                    {
                      message: error.response.data,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'danger'
                    })
                  console.log(error);
              })
            }
        })
        .catch(error=>{
            console.log(error)
        })
      },
      EditHouse(ID){
        this.selectedHouse = this.items.filter(item=> item.houseId == ID)[0];
        this.$bvModal.show('modal-top-EditHouse');
      },
      submitEditForm(){
        this.$bvModal.msgBoxConfirm('Are you sure you want to submit this form?', {
            title: 'Confirm',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'success',
            cancelVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            bodyClass: 'm-2',
            hideHeaderClose: false,
            centered: false
        })
        .then(value => {
            if(value === true){
              var houseUpdate = { building:{
                      buildingId: this.selectedHouse.building.buildingId
                    },
                    buildingId: this.selectedHouse.building.buildingId,
                    createdBy: sessionStorage.getItem("userID"),
                    size: this.selectedHouse.size,
                    floor: this.selectedHouse.floor,
                    roomNumber: this.selectedHouse.roomNumber,
                    id: this.selectedHouse.houseId,
                    priceOption: this.selectedHouse.priceOption,
                    rentCurrencyType: this.selectedHouse.rentCurrencyType,
                    includeVat: this.selectedHouse.includeVat,
                    description: this.selectedHouse.description
              };
              this.$store.dispatch('EditHouse', houseUpdate)
              .then(response=>{
                console.log("json:",houseUpdate);
                console.log("response:",response)
                  this.$notifications.notify(
                    {
                      message: `The House Successfully Updated.`,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'success'
                    })
                    this.$bvModal.hide('modal-top-EditHouse');
                    this.clearData();
                    this.getHouseByOwnerID();
                    this.refreshSelectedHouseDetails();
              })
              .catch(error=>{
                console.log(error);
                this.$notifications.notify(
                    {
                      message: error.response.data,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'danger'
                    })
                  console.log(error);
              })
            }
        })
        .catch(error=>{
            console.log(error)
        })
      },
      ViewDetail(ID){
        this.$store.dispatch('GetHouseDetailById', {houseId: ID})
        .then(response=>{
          this.selectedHouse = response.data;
         // console.log("some", response.data);
            this.$bvModal.show('modal-top-Details');
            this.clearData();
        })
        .catch(error=>{
          this.$notifications.notify(
              {
                message: error.response.data,
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'danger'
              })
            console.log(error);
        })
      },
      getOptionPrice(option){
        if(option != undefined){
          if(option === null) return "";
          else {
            var optionList = this.priceOptions.filter(x=>x.value == option);
            if(optionList.length > 0)
              return this.priceOptions.filter(x=>x.value == option)[0].text;
            else
              return "";
          }
        }else{
          return "";
        }
      },
      getTotalUnpaidBills(){
        if (!this.selectedHouse.OtherPriceInformation) return 0;
        
        let total = 0;
        this.selectedHouse.OtherPriceInformation.forEach(bill => {
          if (bill.paymentStatus === 'Unpaid') {
            total += (bill.electricPrice || 0) + (bill.waterPrice || 0) + 
                    (bill.parkingPrice || 0) + (bill.internetPrice || 0) + 
                    (bill.otherPrice || 0);
          }
        });
        return total;
      },
      ViewBills(houseId){
        this.billsSpinner = true;
        this.$store.dispatch('getBillsByUser', { userId: parseInt(sessionStorage.getItem('userID')) })
          .then(response => {
            const allBills = response.data.Contents || [];
            this.billsList = allBills.filter(bill => bill.houseId === houseId);
            this.$bvModal.show('modal-bills-list');
          })
          .catch(error => {
            this.$notifications.notify({
              message: 'Failed to load bills.',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger'
            });
          })
          .finally(() => {
            this.billsSpinner = false;
          });
      },
      EditBill(bill) {
        this.selectedBill = bill;
        this.editBillData = {
          houseId: bill.houseId,
          startDate: bill.startDate,
          electricReading: bill.electricReading || 0,
          waterReading: bill.waterReading || 0,
          electricBill: bill.electricPrice || 0,
          waterBill: bill.waterPrice || 0,
          parkingPrice: bill.parkingPrice || 0,
          internetPrice: bill.internetPrice || 0,
          otherPrice: bill.otherPrice || 0
        };
        this.$bvModal.show('modal-edit-bill');
      },
      submitEditBillForm() {
        this.$bvModal.msgBoxConfirm('Are you sure you want to update this bill?', {
          title: 'Confirm',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          cancelVariant: 'danger',
          okTitle: 'YES',
          cancelTitle: 'NO',
          bodyClass: 'm-2',
          hideHeaderClose: false,
          centered: false
        })
        .then(value => {
          if (value === true) {
            const updateRequest = {
              houseId: this.editBillData.houseId,
              userId: parseInt(sessionStorage.getItem('ID')),
              createdBy: parseInt(sessionStorage.getItem('userID')),
              startDate: this.editBillData.startDate,
              electricReading: this.editBillData.electricReading,
              waterReading: this.editBillData.waterReading,
              electricBill: this.editBillData.electricBill,
              waterBill: this.editBillData.waterBill,
              parkingPrice: this.editBillData.parkingPrice,
              internetPrice: this.editBillData.internetPrice,
              otherPrice: this.editBillData.otherPrice
            };

            this.$store.dispatch('updateBill', updateRequest)
              .then(response => {
                this.$notifications.notify({
                  message: 'Bill updated successfully.',
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'success'
                });
                this.$bvModal.hide('modal-edit-bill');
                const currentHouseId = this.editBillData.houseId;
                this.clearEditBillData();
                this.ViewBills(currentHouseId);
              })
              .catch(error => {
                this.$notifications.notify({
                  message: (error.response && error.response.data) || 'Failed to update bill.',
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'danger'
                });
              });
          }
        })
        .catch(error => {
          console.error('Error in confirmation modal:', error);
        });
      },
      clearEditBillData() {
        this.editBillData = {
          houseId: null,
          startDate: '',
          electricReading: 0,
          waterReading: 0,
          electricBill: 0,
          waterBill: 0,
          parkingPrice: 0,
          internetPrice: 0,
          otherPrice: 0
        };
        this.selectedBill = {};
      },
      ChangeBillsFromModal() {
        if (this.billsList.length > 0) {
          const houseId = this.billsList[0].houseId;
          this.$bvModal.hide('modal-bills-list');
          this.showBillsOnly = true;
          this.activeTabIndex = 0;
          this.ChangePrice(houseId);
        }
      },
      clearData(){
        this.addData.buildingId = "";
        this.addData.size = 0;
        this.addData.roomNumber = "";
        this.addData.floor = 0;
        this.addData.price = 0;
        this.addData.priceOption = "";
        this.addData.priceOptions = "";
        this.addData.rentCurrencyType="";
        this.addData.electricPrice = 0;
        this.addData.waterPrice = 0;
        this.addData.parkingPrice = 0;
        this.addData.internetPrice = 0;
        this.addData.otherPrice = 0;
        this.buildingOptions = [];
        this.$emit('AfterComplete');
        this.addProperties.propertyName="";
        this.addProperties.status="";
        this.errorMessage = '';
        this.errorMessage1 = '';
        this.errorElectric = '';
        this.errorWater = '';
        this.errorParking = '';
        this.errorInternet = '';
        this.errorOther = '';
      }
    }
  }
</script>
<style scoped>
.error-message {
  color: rgb(219, 63, 63);
  font-size: 0.875rem;
  margin-top: 0.25rem;
}
.b-table-sticky-column:last-child {
  right: 0;
}
.text-warning {
    color: rgba(240, 206, 13, 0.937) !important;
}
.btn-icon {
  font-size: 24px;
  cursor: pointer;
  color: rgb(37, 91, 48);
}
.btn-icon:hover {
  color: rgba(240, 206, 13, 0.937);
}
</style>